const CreditsIconSVG = ({ className }) => (
    <svg
        className={className}
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M9 1.5C4.86 1.5 1.5 4.86 1.5 9C1.5 13.14 4.86 16.5 9 16.5C13.14 16.5 16.5 13.14 16.5 9C16.5 4.86 13.14 1.5 9 1.5ZM9.75 13.5H8.25V12H9.75V13.5ZM11.318 8.318L10.643 9.008C10.103 9.555 9.75 10.005 9.75 11.25H8.25V10.875C8.25 9.968 8.603 9.143 9.143 8.595L10.073 7.65C10.343 7.388 10.5 7.013 10.5 6.6C10.5 5.775 9.825 5.1 9 5.1C8.175 5.1 7.5 5.775 7.5 6.6H6C6 4.95 7.35 3.6 9 3.6C10.65 3.6 12 4.95 12 6.6C12 7.253 11.738 7.845 11.318 8.318Z"
            fill="currentColor"
        />
    </svg>
);

export default CreditsIconSVG;
